import * as fromAuth from '../reducers/authReducers'

export const isAuthenticated = state => fromAuth.isAuthenticated(state.auth)
export const getAccessToken = state => fromAuth.getAccessToken(state.auth)
export const isAccessTokenExpired = state => fromAuth.isAccessTokenExpired(state.auth)
export const getRefreshToken = state => fromAuth.getRefreshToken(state.auth)
export const isRefreshTokenExpired = state => fromAuth.isRefreshTokenExpired(state.auth)
export const getAuthErrors = state => fromAuth.errors(state.auth)